import { useTheme } from '@mui/material';

import ResponseLengthTab from '@webclient/components/response-length-tab';
import SelectionTabs from '@webclient/components/search-forms/gamification-search/actions/filters/components/selection-tabs';

import DownloadFileRoundedIcon from '~icons/knowz-iconify/download-file-rounded';

import { useTranslate } from '@tolgee/react';

export default function ResponseLength() {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <SelectionTabs
      title={t(
        'layout.searchWidget.filters.responseLength.title',
        'Response Length',
      )}
      subtitle={t(
        'layout.searchWidget.filters.responseLength.subtitle',
        'Select your preferred response length below and adjust anytime. Actual length may vary based on your input.',
      )}
      Icon={<DownloadFileRoundedIcon color={theme.palette.utility.gray700} />}
    >
      <ResponseLengthTab />
    </SelectionTabs>
  );
}
